(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["liveblog-web-component"] = factory();
	else
		root["liveblog-web-component"] = factory();
})(self, () => {
return 